var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.72293C0 2.70392 0.363213 1.8312 1.08964 1.10477C1.82615 0.368258 2.70392 0 3.72293 0H9.27707C10.3062 0 11.1839 0.368258 11.9104 1.10477C12.6368 1.8312 13 2.70392 13 3.72293V6.76484C13 7.70314 12.773 8.57082 12.319 9.36787C11.875 10.1548 11.2445 10.7905 10.4272 11.2747L9.11059 12.0617C8.57586 12.3846 8.3085 12.8537 8.3085 13.4692V15.0128C8.3085 15.1339 8.2631 15.2398 8.17229 15.3306C8.09158 15.4113 7.99069 15.4517 7.86962 15.4517H5.13038C5.00931 15.4517 4.90338 15.4113 4.81257 15.3306C4.73186 15.2398 4.6915 15.1339 4.6915 15.0128V13.4692C4.6915 12.5309 4.91851 11.6682 5.37253 10.8813C5.82654 10.0943 6.46217 9.45363 7.27939 8.95926L8.59604 8.18743C9.13077 7.86457 9.39814 7.39038 9.39814 6.76484V3.72293C9.39814 3.69267 9.383 3.66744 9.35274 3.64726C9.33256 3.62709 9.30733 3.617 9.27707 3.617H3.72293C3.69267 3.617 3.66744 3.62709 3.64726 3.64726C3.62709 3.66744 3.617 3.69267 3.617 3.72293V6.03842C3.617 6.15949 3.57159 6.26038 3.48079 6.34109C3.40008 6.42181 3.29919 6.46217 3.17811 6.46217H0.438882C0.317811 6.46217 0.211874 6.42181 0.121071 6.34109C0.040357 6.26038 0 6.15949 0 6.03842V3.72293ZM8.3085 21.5355C8.3085 21.6465 8.2631 21.7474 8.17229 21.8382C8.09158 21.9189 7.99069 21.9593 7.86962 21.9593H5.13038C5.00931 21.9593 4.90338 21.9189 4.81257 21.8382C4.73186 21.7474 4.6915 21.6465 4.6915 21.5355V18.7811C4.6915 18.6702 4.73186 18.5743 4.81257 18.4936C4.90338 18.4028 5.00931 18.3574 5.13038 18.3574H7.86962C7.99069 18.3574 8.09158 18.4028 8.17229 18.4936C8.2631 18.5743 8.3085 18.6702 8.3085 18.7811V21.5355Z",
    fill: "url(#paint0_linear_5247_76978)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5247_76978",
    x1: 8.01765e-9,
    y1: 11.7116,
    x2: 13,
    y2: 11.7116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.82c968a38141f002fddffcdf3702fe5d.svg";
export { ForwardRef as ReactComponent };